<template>
  <v-btn
    color="error"
    large
    :to="$_getRouteDelete(role,model.key,$route.params.id,me)"
  >
    {{$t("action.delete")}}
  </v-btn>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components:{
      //
    },
    computed: mapState({
      //
    }),
    props:[
      'me',
      'role',
      'model',
    ],
    data: () => ({
      //
    }),
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>